<template>
<div class="pa-4">
  <div class="d-flex align-start justify-space-between">
    <LeagueTimeSettings
      class="mb-6"
      :hideTeam="true"
      @refresh="handleRefresh()"
    />
    <div v-if="$vuetify.breakpoint.mobile" style="width: 50px;">
      <v-btn fab small @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
  </div>
  <div class="d-flex" style="width: 100%;">
    <div style="flex-grow: 1; max-width: calc(100%);" class="flex-grow d-flex flex-column align-center justify-center">
      <h4 class="text-h4">{{ currentPlayer.name }}</h4>
      <Table
        @rowClicked="handleRowClick"
        style="width: 100%;"
        class="mt-6"
        :loading="loadingIndividualRuns"
        :data="finalDataSet"
        emptyText="Ei aikoja"
        subtitle="Avaa etenemisen video klikkaamalla riviä"
      ></Table>
    </div>
  </div>
  <PlayClip
    v-if="playingTime"
    :visible="playingTime"
    :manual_clip="playingTime"
    @close="playingTime = null"
    :showCommentBtn="false"
  >
    <v-btn v-if="user.tiimio_admin" class="ml-2" small color="error" @click="deleteRun">
      <v-icon small>mdi-delete-outline</v-icon>
    </v-btn>
    <v-btn v-tooltip="'Ilmoita virheestä'" class="ml-2" small @click="snitchRun()">
      <v-icon color="red">mdi-alert-circle-outline</v-icon>
      <span v-if="!$vuetify.breakpoint.mobile">Virhe</span>
    </v-btn>
    <!-- <v-btn outlined v-tooltip="'Ilmoita virheestä'" class="ml-2" small color="error" @click="snitchRun">
      <v-icon small>mdi-alert-circle-outline</v-icon>
    </v-btn> -->
  </PlayClip>

  <ErrorReportDialog
    v-model="showErrorDialog"
    :run_id="playingTime?.id"
    :event_id="playingTime?.eventId"
    :game_id="playingTime?.gameId"
    :type="is_play ? 'play' : 'run'"
    title="Virhe mittauksessa"
    :hint="!is_play ?
      'Aikojen pitäisi olla lennolla tai nopealla väärällä täysillä edettyjä etenemisiä.' :
      'Mitatun suorituksen pitäisi olla kärkietenijän polttoyritys, joka on suoritettu täysillä tai lähes täysillä.'
    "
  />

  <ConfirmationDialog
    :show="showDeleteConfirmation"
    text="Poista aika"
    subText="Haluatko varmasti poistaa tämän ajan?"
    btnText="Poista"
    btnColor="error"
    @accept="confirmDelete"
    @decline="showDeleteConfirmation = false"
  />
</div>
</template>

<script>
import Table from '@/components/table/Table.vue';
import LeagueTimeSettings from '@/components/leaguetimes/LeagueTimeSettings.vue';
import PlayClip from '@/components/video/PlayClip.vue';
import ErrorReportDialog from '@/components/ErrorReportDialog.vue';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['is_play'],
  components: { Table, LeagueTimeSettings, PlayClip, ErrorReportDialog, ConfirmationDialog },
  data: () => ({
    refreshWhenClosed: false,
    playingTime: null,
    showErrorDialog: false,
    showDeleteConfirmation: false
  }),
  methods: {
    close() {
      this.$emit('close')
    },
    ...mapActions('leaguetimes', [
      'getPlayerRuns'
    ]),
    ...mapActions('videos', [
      'deleteTimeAdmin'
    ]),
    ...mapActions('noti', [
      'info'
    ]),
    deleteRun() {
      this.showDeleteConfirmation = true
    },
    handleRefresh() {
      this.refreshWhenClosed = true
      this.$nextTick(() => {
        this.getPlayerRuns({ player_id: this.currentPlayer.id, league_id: this.currentTeam.league_id })
      })
    },
    handleRowClick(rowIndex) {
      const run = this.individualRuns[rowIndex]
      const firstTime = run.first_time_video_time
      const starttime = Math.max(0, (firstTime - 3))
      const possible = [
        { text: 'Syöttö nousee', key: 'syotto_time' },
        { text: 'Maila laskee', key: 'bat_drops_time' },
        { text: 'Etenijä lähtee', key: 'lahto_time'},
        { text: 'Lyönti osuu mailaan', key: 'hit_time'},
        { text: 'Etenijä pesässä', key: 'runner_at_base_time' },
        { text: 'Pallo hallussa', key: 'possession_time'},
        { text: 'Heitto lähtee', key: 'throw_time' },
        { text: 'Pallo pesässä', key: 'ball_at_base_time' },
      ]
      this.playingTime = {
        id: run.id,
        starttime: starttime,
        endtime: firstTime + run.total_time + 3,
        title: run.player_name,
        eventId: run.event_id,
        video_url: run.video_url,
        gameId: run.game_id,
        dataPoints: [],
        firstTime: run.first_time_video_time,
        timenames: possible.map(p => {
          const t = run[p.key]
          return {
            name: p.text,
            time_from_first: t,
            video_time: t !== null ? run.first_time_video_time + t : null
          }
        }).filter(t => !!t.video_time)
      }

      console.log(this.playingTime.timenames)
    },
    snitchRun() {
      this.showErrorDialog = true
    },
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60)
      const remainingSeconds = (seconds % 60).toFixed(2)
      return `${minutes}:${remainingSeconds.padStart(5, '0')}`
    },
    confirmDelete() {
      this.deleteTimeAdmin(this.playingTime.id)
        .then(() => {
          this.info('Aika poistettu')
        })
      this.showDeleteConfirmation = false
    }
  },
  computed: {
    ...mapGetters('leaguetimes', [
      'loadingIndividualRuns',
      'individualRuns',
      'currentPlayer',
      'base',
      'isPlay'
    ]),
    ...mapGetters('user', [
      'currentTeam',
      'user'
    ]),
    finalDataSet() {
      let dataSet = { ...this.dataSet }
      dataSet.headers = dataSet.headers.filter(h => {
        let shouldInclude = true;

        if(h.bases) {
          shouldInclude = shouldInclude && h.bases.includes(this.base);
        }
        if(h.leagues) {
          shouldInclude = shouldInclude && h.leagues.includes(this.currentTeam.pesis_league_name);
        }
        if(h.is_play !== undefined) {
          shouldInclude = shouldInclude && h.is_play === this.isPlay;
        }

        return shouldInclude;
      });

      return dataSet;
    },
    dataSet() {
      return {
        headers: [
          { text: 'Päivä', value: 'day', center: true, width: '70px', locked: true },
          {
            bases: [1, 2, 3],
            text: 'Aika',
            is_play: false,
            bold: true,
            value: 'time',
            center: true,
            width: '100px'
          },
          {
            bases: [0],
            text: 'Aika',
            is_play: false,
            bold: true,
            value: 'time',
            tooltip: "Lyönti osuu mailaan -> etenijä pesässä", center: true, width: '100px'
          },
          {
            text: 'Aika',
            is_play: true,
            bold: true,
            value: 'ball_at_base_time',
            center: true,
            width: '100px'
          },
          {
            text: 'Suoritus',
            is_play: true,
            bold: false,
            value: 'suoritus_time',
            tooltip: "Lyönti osuu mailaan -> pallo pesässä",
            center: true,
            width: '100px'
          },
          {
            bases: [1, 2, 3],
            text: 'Lähtö',
            is_play: false,
            value: 'lahto_time',
            center: true,
            width: '80px'
          },
          {
            bases: [1, 2, 3],
            text: 'Juoksu',
            is_play: false,
            value: 'juoksu_time',
            center: true,
            width: '80px'
          },
          {
            bases: [1, 2],
            is_play: false,
            text: 'Lähdön etäisyys',
            value: 'distance_from_base',
            leagues: ['msu', 'nsu'],
            center: true,
            width: '170px', label: true, labelColor: () => ''
          },
        ],
        items: this.individualRuns.map((run) => {
          return [
            { key: 'day', value: run.formatted_date },
            { key: 'time', value: run.runner_at_base_time?.toFixed(2) || '-' },
            { key: 'lahto_time', value: run.lahto_time?.toFixed(2) || '-' },
            { key: 'ball_at_base_time', value: run.ball_at_base_time?.toFixed(2) || '-' },
            { key: 'suoritus_time', value: run.suoritus_time?.toFixed(2) || '-' },
            { key: 'throw_speed', value: run.throw_speed ? (run.throw_speed?.toFixed(0) + ' km/h') : '-' || '-' },
            { key: 'juoksu_time', value: run.juoksu_time?.toFixed(2) || '-' },
            { key: 'distance_from_base', value: run.distance_from_base ? (run.distance_from_base?.toFixed(1) + ' m' ) : '-' || '-' },
          ]
        })
      }
    }
  },
  destroyed() {
    if(this.refreshWhenClosed) {
      this.$emit('refresh')
    }
  }
}
</script>

{
  "id": 11729,
  "starttime": 3624.04874,
  "endtime": 3633,
  "video_id": null,
  "title": "Kelpo meno",
  "description": null,
  "created": "2025-03-07T22:00:00.000Z",
  "game_id": "cb8590eb-756e-4a9e-ab2e-4391573b2b15",
  "leaguewide": null,
  "team_id": 581,
  "is_point": 0,
  "map_color": null,
  "creator": "testi@epesis.com",
  "league_id": 8,
  "home_club_id": 52,
  "away_club_id": 59,
  "score_home": null,
  "score_away": null,
  "starttime_unix": 1741431600000,
  "publishtime_unix": 1741440600000,
  "analyzed": 0,
  "will_be_analyzed": 0,
  "video_url": "https://dpe7aw9wpk40m.cloudfront.net/9da28b65-a26a-45fb-9435-f224146f90e8/vod.m3u8",
  "video_type": "hsl",
  "game_info": "",
  "game_error": "",
  "shown_live": 1,
  "season_id": 6,
  "external_service_id": "107154",
  "video_live_url": "https://dpe7aw9wpk40m.cloudfront.net/9da28b65-a26a-45fb-9435-f224146f90e8/live.m3u8",
  "done_analysis_state": null,
  "stadion_id": null,
  "pitching_referee_id": null,
  "archived": 0,
  "enable_auto_updates": 1,
  "season_state": "Alkulohkot - Miesten Talvisuper",
  "tags": [],
  "num_of_tags": 0,
  "points": [],
  "graphics": { "layers": [], "objects": [], "original_video_width": 1198 },
  "timenames": [
    {
      "timename_id": 1976,
      "time_id": null,
      "video_time": 3626.0487,
      "time_from_first": 0,
      "pretty_time": "",
      "clip_id": 11729,
      "id": 1976,
      "team_id": 581,
      "hidden": null,
      "position": null,
      "name": "Syöttö nousee",
      "created": "0000-00-00 00:00:00"
    }, { "timename_id": 1977, "time_id": null, "video_time": 3626.4487, "time_from_first": 0.4, "pretty_time": "", "clip_id": 11729, "id": 1977, "team_id": 581, "hidden": null, "position": null, "name": "Etenijä lähtee", "created": "0000-00-00 00:00:00" }, { "timename_id": 1978, "time_id": null, "video_time": 3631.1287, "time_from_first": 5.08, "pretty_time": "", "clip_id": 11729, "id": 1978, "team_id": 581, "hidden": null, "position": null, "name": "Etenijä pesässä", "created": "0000-00-00 00:00:00" } ] }